import { SELF, VERIFIED } from "../../internal/shared/permissions/symbols";
export const ALLOWLISTED_V2_PERMISSIONS = {
    ZZTest_bar: true,
    ZZTest_biz: true,
    ZZTest_foo: true
};
/**
 * @see https://sail.stripe.me/data/api/checkPermissions
 */ export default function checkPermissions(/**
   * This is the token in which you want to check for one or more permissions.
   * This type of this parameter **cannot** be a union.
   */ token, /**
   * Specifies the extra permissions you want to check for. It will refine the token
   * to add those too.
   */ additionalPermissions) {
    if (!token) {
        return undefined;
    }
    return !additionalPermissions || !token[VERIFIED] || token && Object.keys(additionalPermissions).every((permission)=>{
        const permissionValue = token[SELF][permission];
        // For now, checkPermissions() always returns true for non-V2 permissions
        // because inlineRetrievePermissions() only returns V2 permissions.
        if (!permission.startsWith('Mutation_v2') && !permission.startsWith('Query_v2') && !(permission in ALLOWLISTED_V2_PERMISSIONS)) {
            return true;
        }
        const value = additionalPermissions[permission];
        return Array.isArray(permissionValue) ? permissionValue.includes(value) : permissionValue === value;
    }) ? token : undefined;
}

//# sourceMappingURL=checkPermissions.js.map